import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { InsightsNotes } from './insights-notes.model';

@Injectable()
export class InsightsNotesService {

  constructor(private http: HttpClient) { }
}
